module.exports = "<div class=\"add-player-to-group\">\r\n\t<div class=\"player-image\"\r\n\t\tstyle=\"background-image:url(<%- data.photoURL %>)\">\r\n\t</div>\r\n\t<div>\r\n\t\t<p><%- data.name %> <%- data.surname %></p>\r\n\t</div>\r\n\t<div class=\"clearfix\"></div>\r\n\t<button class=\"btn btn-sm btn-primary btn-add-player\">\r\n\t\tAdd this player\r\n\t</button>\r\n\t<div class=\"alert alert-success hidden\">\r\n\t\t<strong>Added!</strong>\r\n\t</div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/admin-section/groups/group/_modals/add-player-to-group-modal/add-player/add-player.tpl.html
// module id = 91
// module chunks = 0